import { AppBar, Box, Button, Chip, Divider, FormControl, FormHelperText, Grid, Hidden, Input, InputLabel, makeStyles, MenuItem, Paper, Select, Tab, Tabs, TextField, Tooltip, Typography } from '@material-ui/core';
import { useFormik, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
// import "../../assets/css/master.css";

import { selectUsuarioSeleccionado } from '../../../redux/reducer/loginReducer';
import * as yup from 'yup';
// import { addFactura } from '../../../services/inquilino';
import { DataGrid } from '@mui/x-data-grid';
import TemplateForm from '../../../components/TemplateForm/TemplateForm';
import { insert_nota, update_nota_fecha_aviso } from '../../../services/alumnos_notas';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import Moment from 'react-moment';
import { DataGridPro } from '@mui/x-data-grid-pro';

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 90
        // display: 'flex',
        // flexWrap: 'wrap',
    },
    textField: {
        // marginLeft: theme.spacing(1),
        // marginRight: theme.spacing(1),
    },
    keyboardDatePicker: {
        // marginLeft: theme.spacing(1),
        // marginRight: theme.spacing(1),
    },
    formulario: {
        margin: 8
    },
    input: {
        display: 'none'
    },
}));

/* -------------------------------------------------------------------------- */
/*                            Esquema de valicación                           */
/* -------------------------------------------------------------------------- */
const validationSchema = yup.object({

    // nombre: yup.string().required("Nombre es requerido"),
    // apellidos: yup.string().required("Apellidos son requeridos"),
    // telefono: yup.string().required("Telefono es requerido"),
    // correo: yup.string().email().required("Correo es requerido"),
    
  });


const AlumnosNotasForm = ({alumno_id, notas}) => {
    // const classes = useStyles();

    let history = useHistory();
    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });
    const [loading, setLoading] = useState(false)
    const [alumno, setAlumno] = useState(undefined)
    const [notasAlumno, setNotasAlumno] = useState(notas)
    
    const [initialValues, setInitialValues] = useState({
        nota:  "",
        fecha_aviso:  null
    })
    const [notaSeleccionada, setNotaSeleccionada] = React.useState(undefined);

    /* -------------------------------------------------------------------------- */
    /*                                  UseEffect                                 */
    /* -------------------------------------------------------------------------- */
    useEffect(() => {
        const usuario_id = usuarioSeleccionado.id
        
        setLoading(true);

    // const [comerciales, setComerciales] = useState(undefined)
    }, [])

    /* -------------------------------------------------------------------------- */
    /*                                  UseFormik                                 */
    /* -------------------------------------------------------------------------- */
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {


            insert_nota({
                usuario_id: usuarioSeleccionado.id,
                alumno_id: alumno_id,
                nota: values.nota,
                fecha_aviso: values.fecha_aviso
            }).then( (response) => {
                response && setNotasAlumno(response.notas)
                formik.setFieldValue('nota', "");
                formik.values.nota = ""
                formik.values.fecha_aviso = ""
            })

            // setLoading(true)

            // if( inquilino === undefined ) {
            //     inquilinoCreate(usuarioSeleccionado.id, values).then( (response) => {
                    
            //         setLoading(false)

            //         history.goBack()
                    
            //     })
            // } else {

            //     inquilinoUpdate(usuarioSeleccionado.id, values).then( (response) => {

            //         history.goBack()

            //     })
            // }
        },
      });

      
    const columnas_notas = [
        {
            'field': 'nota', 
            flex: 1,
            'headerName': 'Nota', 
            'description': 'Nota',
            renderCell: (cellValues) => {
                return (
                    <>
                    <Tooltip title={cellValues.value} >
                        <span className="table-cell-trucate">{cellValues.value}</span>
                    </Tooltip>
                    </>
                );
            } 
        },
        {
            'field': 'fecha_aviso', 
            'width':120, 
            'headerName': 'Aviso', 
            'description': 'Fecha de aviso',
            type: 'date',
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY hh:mm A"),
            renderCell: (cellValues) => {
              return (
                
                  (cellValues.value !== null && cellValues.value !== undefined && cellValues.value !== "0000-00-00 00:00:00") ?
          
                  <Moment format="DD/MM/YYYY">
                    {cellValues.value}
                  </Moment>
          
                  :
          
                  <></>
          
                
              );
            }, 
            editable: true 

          },
        {
            'field': 'created', 
            'width':160, 
            'headerName': 'Creado', 
            'description': 'Fecha de creación',
            type: 'date',
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY hh:mm A"),
            renderCell: (cellValues) => {
              return (
                
                  (cellValues.value !== null && cellValues.value !== undefined && cellValues.value !== "0000-00-00 00:00:00") ?
          
                  <Moment format="DD/MM/YYYY hh:mm:ss">
                    {cellValues.value}
                  </Moment>
          
                  :
          
                  <></>
          
                
              );
            },
          },
        { field: 'created_usuario_nombre', headerName: 'Creado por', maxWidth: 250, flex: 1 },

    ];

    return (
        <>
                <form noValidate method="POST" enctype="multipart/form-data" autoComplete="off" onSubmit={ formik.handleSubmit }>

                    <Grid container  spacing={2}>
                        <Grid item xs={8} md={8}>

                            <TextField
                                id="nota"
                                name="nota"
                                label="Nota"
                                placeholder="Añade una nota"
                                fullWidth
                                multiline
                                rows={3}
                                margin="normal"
                                value={formik.values.nota}
                                onChange={formik.handleChange}
                                variant="outlined"
                                error={formik.touched.nota && Boolean(formik.errors.nota)}
                                helperText={formik.touched.nota && formik.errors.nota}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3} md={2} style={{marginTop: 16}}>

                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    fullWidth
                                    id="fecha_aviso"
                                    label="Fecha aviso"
                                    placeholder='Introduce la fecha de aviso'
                                    inputVariant="outlined"
                                    format="dd/MM/yyyy"
                                    value={formik.values.fecha_aviso}
                                    onChange={value => formik.setFieldValue("fecha_aviso", value)}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date"
                                    }}
                                    error={formik.touched.fecha_aviso && Boolean(formik.errors.fecha_aviso)}
                                    helperText={formik.touched.fecha_aviso && formik.errors.fecha_aviso}
                                />
                            </MuiPickersUtilsProvider>

                        </Grid>

                        <Grid item xs={12} md={2} >

                            <Button 
                                fullWidth
                                variant="contained" 
                                color="primary" 
                                type="submit"
                                size='large'
                                style={{marginTop: '16px'}}
                            >
                                Guardar
                            </Button>

                        </Grid>
                    </Grid>
                </form>
            { 
                notasAlumno && 
                    <div style={{ height: 500, width: '100%', padding:"" }}>
                        <DataGrid 
                            getRowHeight={() => 'auto'}
                            rows={notasAlumno} 
                            columns={columnas_notas} 
                            onCellEditCommit={(params) => {
                                console.log(params)
                                if(params.field === "fecha_aviso") {
                                    update_nota_fecha_aviso({
                                        usuario_id: usuarioSeleccionado.id,
                                        nota_id: params.id,
                                        fecha_aviso: params.value
                                    }).then( (response) => {
                                        console.log("🚀 ~ file: AlumnosNotasForm.js:278 ~ AlumnosNotasForm ~ response:", response)
                                    })
                                }
                            }}
                        />
                    </div>
                }


        </>
    )
};

export default AlumnosNotasForm;